import React from 'react';
import LoadingSpinner from './loadingSpinner'
import IconButton from '@material-ui/core/IconButton';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import C18Button00 from './C18Button00'
import C18TabsHeader00 from './C18TabsHeader00'
import C18SaveCancel00 from './C18SaveCancel00'
import UsaCheckbox00 from './UsaCheckbox00';
import C18PearlMapping01 from './C18PearlMapping01';
import {loadZonesInfo,getZoneInfo, loadSiteData,loadGatewaysInfo,getSiteName,getZoneName,
  loadSensorsInfo,getSensorsZone,privs,loadCamerasInfo,intToBase64} from './C18utils'
import {wsTrans,getParamId,getChannelsInfo,loadAddedSensors,
  getParamId2,isHydroRoot16
} from '../utils/utils'
import {pi,pInd} from '../../components/utils/paramIds';
import {dbVals,getZValue,getZoneControllers} from '../../components/utils/http';
import {cl,az,globs,constant,isHydroR} from '../../components/utils/utils';
import history from '../../history'
import {makeSensorList,getSetSensorName,fixSensorList} from '../utils/sensorNames'


class C18PearlMapping02 extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
//     cl(globs.userData);
    this.state={
      loaded: true,
      mode: "selection",
      sensorOrder:["inT", "stT", "ouH"],
      lastMoved: null,
      sensorList:makeSensorList(props.parms.adminPage),
    }
//     cl(this.state.sensorList)
//     cl(this.state.sensorList[0].s[0])
//     cl(this.state.sensorList[0].s[0].v)
//     this.defaultNames=[
//       {v:"zoS",t:"Zone Setpoint"},
//       {v:"inT",t:"Inside Temperature"},
//       {v:"inH",t:"Inside Humidity"},
//       {v:"inL",t:"Inside Light"},
//       {v:"inC",t:"Inside CO2"},
//       {v:"vpd",t:"VPD"},
//       {v:"ouT",t:"Outside Temperature"},
//       {v:"ouH",t:"Outside Humidity"},
//       {v:"ouL",t:"Outside Light"},
//       {v:"bpT",t:"Black Plate Temp"},
//       {v:"at0", t:"Analog Temperature 1"},
//       {v:"at1", t:"Analog Temperature 2"},
//       {v:"at2", t:"Analog Temperature 3"},
//       {v:"at3", t:"Analog Temperature 4"},
//       {v:"at4", t:"Analog Temperature 5"},
//       {v:"vp0", t:"Vent Position 1"},
//       {v:"vp1", t:"Vent Position 2"},
//       {v:"vp2", t:"Vent Position 3"},
//       {v:"vp3", t:"Vent Position 4"},
//       {v:"vp4", t:"Vent Position 5"},
//       {v:"sm0", t:"Soil Moisture 1"},
//       {v:"sm1", t:"Soil Moisture 2"},
//       {v:"sm2", t:"Soil Moisture 3"},
//       {v:"sm3", t:"Soil Moisture 4"},
//       {v:"sm4", t:"Soil Moisture 5"},
//       {v:"c00",t:"Channel 1"},
//       {v:"c01",t:"Channel 2"},
//       {v:"c02",t:"Channel 3"},
//       {v:"c03",t:"Channel 4"},
//       {v:"c04",t:"Channel 5"},
//       {v:"c05",t:"Channel 6"},
//       {v:"c06",t:"Channel 7"},
//       {v:"c07",t:"Channel 8"},
//       {v:"c08",t:"Channel 9"},
//       {v:"c09",t:"Channel 10"},
//       {v:"c10",t:"Channel 11"},
//       {v:"c11",t:"Channel 12"},
//       {v:"ec0", t:"EC1"},
//       {v:"ph0", t:"pH1"},
//       {v:"tp0", t:"Temp1"},
//       {v:"ec1", t:"EC2"},
//       {v:"ph1", t:"pH2"},
//       {v:"tp1", t:"Temp2"},
//       {v:"ec2", t:"EC3"},
//       {v:"ph2", t:"pH3"},
//       {v:"tp2", t:"Temp3"},
//       {v:"ec3", t:"EC4"},
//       {v:"ph3", t:"pH4"},
//       {v:"tp3", t:"Temp4"},
//       {v:"ec4", t:"EC5"},
//       {v:"ph4", t:"pH5"},
//       {v:"tp4", t:"Temp5"},
//       {v:"ec5", t:"EC6"},
//       {v:"ph5", t:"pH6"},
//       {v:"tp5", t:"Temp6"},
//       {v:"ec6", t:"EC7"},
//       {v:"ph6", t:"pH7"},
//       {v:"tp6", t:"Temp7"},
//       {v:"ec7", t:"EC8"},
//       {v:"ph7", t:"pH8"},
//       {v:"tp7", t:"Temp8"},
//     ]
//     cl(this.state.sensorList)
    this.sensorIds={}
    this.state.checks={}
//     this.loadSensors()
//     cl(this.props)
    this.saveOK=privs("zone",this.props.parms.zone,constant.AREA_PRIVS_WRITE)
    if(this.saveOK){
      this.props.parms.onChange({cmd: "savePage", data:{savePage: true}})//,saveEnable:false
    }
    this.setBreadCrumbs()
//     props.parms.onChange({cmd: "savePage", data:{savePage: true,saveEnable:false}})
//     this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",this.saveCancel)
//     this.getSetSensorName("inT","not In Temp",true)
//     this.subscribe_renameSensorEvent=globs.events.subscribe("renameSensor",this.renameSensor)
//     this.subscribe_keyUp=globs.events.subscribe("keyUp",this.keyUp)
  }

  setBreadCrumbs=()=>{
//     cl(this.props)
    let zoneName=getZoneName(this.props.parms.zone)
    let siteName=getSiteName(this.props.parms.site)
    let siteId=this.props.parms.site
    let zoneId=this.props.parms.zone
    let gwType=getZoneInfo(zoneId)?.gatewayType||1800
    let zoneBCI=[
      {t:"Sites", url:"/usa/c18/sites"},
      {t:siteName, url:`/usa/c18/sites/${siteId}`},
      {t:zoneName, url:`/usa/c18/sites/${siteId}/zones/${zoneId}`},
      {t:"Sensor Settings", url:`/usa/c18/sites/${siteId}/zones/${zoneId}/settings/sensor${gwType}`},
      {t:"Input Mapping", url:`/usa/c18/sites/${siteId}/zones/${zoneId}/pearl/mapping`},
    ]
    this.props.parms.onChange(
      {
        cmd: "breadcrumbs",
        data:
          {breadcrumbs: zoneBCI},
      },
    )
  }

  saveCancel=async(cmd)=>{
//     cl(cmd)
    let order=this.state.sensorOrder
//     cl(order)
    if(cmd=="save"){
      if(this.state.mode=="selection"){
        order=this.makeNewOrderSensors()
      }
      await this.saveSensors(order)
      await this.saveSensorNames()
      globs.events.publish("saveOK",true)
      this.setState({editName:""})
    }
//     let url=`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}`
//     history.push(url)
  }

  openClose=(id,cmd)=>{
    let sensors=this.state.sensorList.slice(0)
    switch(cmd){
      case "Show":
        this.sensorIds[id].o=1
        break
      case "Hide":
        this.sensorIds[id].o=0
        break
      default:
        break
    }
    this.setState({sensorList:sensors})
  }

  showIcon=(id,MyCon,result)=>{
//     return null
    return(
      <IconButton
        onClick={()=>result(id)}
        style={{display: "inline", padding: 0}}>
          <MyCon/>
      </IconButton>
    )
  }

  result=(type)=>{
//     cl(type)
    let parts=type.split("-")
    switch(parts[1]){
      case "Show":
        this.openClose(parts[0],parts[1])
        break
      case "Hide":
        this.openClose(parts[0],parts[1])
        break
      case "check":
        globs.events.publish("savePageEnable",true)
        let checks=Object.assign({},this.state.checks)
        let id=parts[0]
        checks[id]=!checks[id]
        this.setState({checks:checks})
        break
      case "button":
        if(parts[0]=="order"){
          let newOrder=this.makeNewOrderSensors()
          this.setState({mode:parts[0], sensorOrder:newOrder})
        }else{
          this.setState({mode:parts[0]})
        }
        break
//       case "ArrowUp":
//       case "ArrowDn":
//         this.arrowUpDn(parts[0],parts[1])
//         break
      default:
        break
    }
//     switch(p
//     cl(type)
  }

  arrowUpDn=(id,dir)=>{
    globs.events.publish("savePageEnable",true)
//     cl([id,dir])
    let order=this.state.sensorOrder.slice(0)
    let pos=order.indexOf(id)
    if(dir=="ArrowUp"){
      if(pos>0){
        [order[pos-1],order[pos]]=[order[pos],order[pos-1]]
      }
    }else{
      if(pos<order.length-1){
        [order[pos+1],order[pos]]=[order[pos],order[pos+1]]
      }
    }
    this.setState({sensorOrder:order,lastMoved:id})
//     cl(pos)

  }

  selectAll=(sl, all)=>{
//     cl([sl,all])
    globs.events.publish("savePageEnable",true)
    let checks=Object.assign({},this.state.checks)
    sl.s.forEach(s=>{
      checks[s.v]=!all
    })
    this.setState({checks:checks})
  }

  showSelectBox=(ms,i)=>{
    let gotAll=true
    let {getPopup,onChange,site,zone}=this.props.parms
    return(
      <details id="pearl_mapping_table_01" key={i}>
        <summary>
          <h2>{ms.t}</h2>
        </summary>
        <div className="">
          <C18PearlMapping01
            parms={{
              getPopup,
              onChange,
              parms:{
                search:`?type=${ms.k}`,
              },
              site,
              zone
            }}
          />
        </div>
      </details>
    )
  }

  onChange=(type,vals)=>{
//     cl([type,vals])
    switch(type){
      case "tabs":
//         cl(vals)
        if(vals.tab=="order"){
          let newOrder=this.makeNewOrderSensors()
          this.setState({mode:vals.tab, sensorOrder:newOrder,lastMoved:null})
        }else{
          this.setState({mode:vals.tab})
        }
        break
//       case "saveCancel":
//         let order=this.state.sensorOrder
//         if(vals.saveType=="save"){
//           if(this.state.mode=="selection"){
//             order=this.makeNewOrderSensors()
//           }
//           this.saveSensors(order)
// //           let pos=this.props.parms.url.indexOf("/admin")
//           let url=`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}`
//           history.push(url)
// //           cl(this.props.parms.url.substr(0,pos))
//         }
// //         cl(vals.saveType)
//         break
      case "renameSensor":
//         cl(vals)
        vals.s0.t=vals.t
        globs.events.publish("savePageEnable",true)
        this.setState({sensorList:this.state.sensorList.slice(0)})
        break
      default:
        break
    }
  }

  mappingSections=[
    {t:"Inside",k:"ins"},
    {t:"Outside",k:"out"},
    {t:"Analog Temp",k:"tmp"},
    {t:"Voltage",k:"vlt"},
    {t:"Generic 1-25",k:"gn0"},
    {t:"Generic 26-50",k:"gn1"},
    {t:"Generic 51-75",k:"gn2"},
    {t:"Generic 76-100",k:"gn3"},
    {t:"Generic 101-128",k:"gn4"},
  ]

  render(){
    if(this.state.loaded){
      return(
        <div className="tabs" id="pearl_mapping_table_01">
          <div>
            <div>
              {this.mappingSections.map((ms,i)=>{
                return this.showSelectBox(ms,i)
              })}
            </div>
          </div>
        </div>
      )
    }else{
      return <LoadingSpinner message="Loading..." />
    }
  }
}

export default C18PearlMapping02 ;

